import React from 'react';
import { ESTADOS } from './actividadUtils';

export const EstadoBadge = ({ estado, testid }) => {
  const e = ESTADOS[estado] || ESTADOS.SIN_REGISTRO;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${e.cls}`} data-testid={testid}>
      <span className={`h-1.5 w-1.5 rounded-full ${e.dot} ${estado === 'EN_LINEA' ? 'animate-pulse' : ''}`} />
      {e.label}
    </span>
  );
};

export default EstadoBadge;
